import { useNavigate, useParams, useSearchParams } from "react-router";

import type { PATHS } from "@/routes/paths";
import { NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetNewRoomParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.ROOM.EDIT.NEW.ROOM.DEFAULT>>();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const duplicateItemID = searchParams.get(NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS);

	if (!hotelID) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		duplicateItemID: duplicateItemID,
	};
};
